import React from 'react'

export const Alert = (props) => {
    const capital=(string)=>{
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    return (
        <div style={{height
        :"37px"}}>
       {props.alert && <div>
            <div class={`alert alert-${props.alert.type}`} role="alert">
            <strong>{capital(props.alert.type)}</strong> :{props.alert.message}
            </div>
        </div>}
        </div>
    )
}
